export class toggleContent {
	toggleContentList: NodeList = document.querySelectorAll("[data-toggle-content-header]");
	toggleContentArray: HTMLElement[] = Array.prototype.slice.call(this.toggleContentList);
	activeClass: string = 'is-active';
	constructor() {
		this.toggleContent()
	}
	private toggleContent = () => {
		this.toggleContentArray.forEach((elem) => {
			elem.addEventListener("click", () => {
				(elem.parentNode as HTMLElement).classList.toggle(this.activeClass);
			});
		});
	}
}


